import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { COLORS } from '../../constants/styles';

import ClickableElement from '../ClickableElement';
import Icon from '../Icon';

import styles from './index.styl';

const NewPostBtn = ({ title, handleClick }) => (
  <ClickableElement onClick={handleClick} styleName="newPostBtn">
    <span className="mr2">{title}</span>
    <Icon
      name="arrow-down-forms"
      width={12}
      height={12}
      style={{ fill: COLORS.blueAccent, transform: 'rotate(180deg)' }}
    />
  </ClickableElement>
);

NewPostBtn.propTypes = {
  handleClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default CSSModules(NewPostBtn, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Community/NewPostsBtn.jsx